import { useTranslation } from 'react-i18next';

import OrderTerms from 'components/PlaceOrderFormCommon/OrderTerms/OrderTerms';
import { SectionContainer, StyledButton, ToolTip } from 'components/shared';
import { OrderSummaryAndOrderDetailsPallets } from 'interfaces/commonInterfacesAndTypes';
import { Banner, Divider } from 'storybook';

import PalletAmountList from './PalletAmountList/PalletAmountList';
import PalletAmountSummary from './PalletAmountSummary/PalletsAmountSummary';
import OverviewPalletConfigurationCard from './PalletConfigurationCard/PalletConfigurationCard';
import PalletsSummaryWithTotalPriceAndAmount from './PalletsSummaryWithTotalPriceAndAmount/PalletsSummaryWithTotalPriceAndAmount';
import styles from './OverviewPalletsConfigurationSection.module.css';

type OverviewPalletsConfigurationSectionProps = {
   mode?: 'ORDER_DETAILS' | 'PLACE_ORDER';
   logisticMinimumAchieved?: boolean;
   isOrderFree?: boolean;
   isClientView?: boolean;
   isDisabledEditAction?: boolean;
   pallets: OrderSummaryAndOrderDetailsPallets;
   palletsSum: number;
   palletsTotalPrice?: number;
   onClickEdit?: () => void;
};

const OverviewPalletsConfigurationSection = ({
   mode,
   pallets,
   isOrderFree,
   isClientView,
   isDisabledEditAction,
   logisticMinimumAchieved,
   palletsSum,
   palletsTotalPrice,
   onClickEdit,
}: OverviewPalletsConfigurationSectionProps) => {
   const { t } = useTranslation();

   const summaryContainerContent =
      palletsTotalPrice !== undefined ? (
         <PalletsSummaryWithTotalPriceAndAmount
            palletsTotalPrice={palletsTotalPrice}
            palletsSum={palletsSum}
            isOrderFree={!!isOrderFree}
         />
      ) : (
         <>
            <PalletAmountList pallets={pallets} />
            <PalletAmountSummary palletsSum={palletsSum} />
         </>
      );

   return (
      <SectionContainer title={t('editPalletsConfiguration.title')}>
         {logisticMinimumAchieved === false && (
            <Banner
               style={{ marginBottom: 24 }}
               children={
                  mode === 'ORDER_DETAILS'
                     ? t('overviewPallets.logisticMinimumNotMet.details')
                     : t('overviewPallets.logisticMinimumNotMet.form')
               }
               variant="warning"
               fullWidth
            />
         )}
         {onClickEdit && (
            <ToolTip
               content={t('overviewPallets.tooltip')}
               variant="right"
               visible={isDisabledEditAction}
            >
               <StyledButton
                  variant="outlined-primary"
                  text={t('common.editPallets')}
                  onClick={onClickEdit}
                  disabled={isDisabledEditAction}
               />
            </ToolTip>
         )}
         <div className={styles.summaryCardsContainer}>
            {pallets.map(pallet => (
               <OverviewPalletConfigurationCard
                  key={pallet.name}
                  pallet={pallet}
                  isClientView={isClientView}
                  isOrderFree={isOrderFree}
               />
            ))}
         </div>
         <Divider variant="horizontal" />
         <div className={styles.summaryContainer}>{summaryContainerContent}</div>
         <OrderTerms />
      </SectionContainer>
   );
};

export default OverviewPalletsConfigurationSection;
